export default __webpack_public_path__ + "static/media/OnboardingError.b9b4c9c0.gif";